import styled from 'styled-components';

export const ModaWrapper = styled.div`
  position: relative;
  width: 53%;
  left: ${props => (props.left ? props.left : null)};
  box-shadow: 0 10px 10px 0 rgba(225, 225, 225, 0.5);
  background-color: rgba(0, 103, 120, 0.15);
  margin-top: 15px;
  padding: 15px;
  animation: slide-down 1s ease;
  @keyframes slide-down {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const SliderComponent = styled.div`
  width: 99%;
  display: inline-block;
  .ant-slider {
    margin-top: 10px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      margin-right: 0px;
    }
  }
  .ant-slider-handle {
    border-radius: 0;
    border: transparent;
    width: 10px;
    height: 18px;
    margin-top: -9px;
    margin-left: -5px;
    background-color: ${props =>
      props.disabled
        ? props.theme.backgroundColor.disabled
        : props.theme.backgroundColor.primaryColor};
  }
  .ant-slider-track {
    background-color: ${props => props.theme.backgroundColor.layoutLight};
  }
  .ant-slider:hover .ant-slider-track {
    background-color: ${props => props.theme.backgroundColor.layoutLight};
  }
`;

export const TitleGrid = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const FilterType = styled.span`
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.thead};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
`;

export const ResetLink = styled.a`
  float: ${props => (props.floated ? 'right' : 'none')};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${props => props.theme.fontColors.primary};
    text-decoration: underline;
  }
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const MinMaxWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Min = styled.div`
  color: ${props => props.theme.fontColors.headingColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  background-color: ${props => props.theme.backgroundColor.layoutLight};
  width: 75px;
  height: 30px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  @media only screen and (max-width: 520px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const Max = styled.div`
  color: ${props => props.theme.fontColors.headingColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  background-color: ${props => props.theme.backgroundColor.layoutLight};  
  width: 75px;
  height: 30px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  @media only screen and (max-width: 520px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const CloseControl = styled.div`
  display: flex;
  align-self: flex-end;
  & > span {
    font-size: ${props => props.theme.fontSize.primary};
    color: ${props => props.theme.colors.primaryColor};
    line-height: 1.5;
  }
`;

export const BottomWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
`;

export const CloseText = styled.button`
  outline: none;
  cursor: pointer;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  background: none;
  border: none;
  color: #006778;
  text-decoration: underline;
  & > svg {
    font-size: 10px;
  }
`;
export const PoweredBy = styled.span`
  display: flex;
  align-items: center;
  & > span {
    margin-right: 10px;
    font-size: 10px;
  }
`;

export const Wrapper = styled.div`
  ${({ Flex }) =>
    Flex &&
    `
  display: flex;
  `}
  ${({ Background }) =>
    Background &&
    `
  padding: 0 14px 0 13px;
  background-color: rgba(0, 103, 120, 0.15);
  box-shadow: 0 10px 10px 0 rgba(225, 225, 225, 0.5);
  height: auto; 
  `}
  ${({ CloseBtn }) =>
    CloseBtn &&
    `
  padding: 39px 0 42px 0;
  display: flex;
  justify-content: flex-end;
  `}
  ${({ PaddingTop }) =>
    PaddingTop &&
    `
    padding-top: 39px;
    & > p {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      font-size: 14px;
      line-height: 20px;
      color: #505050;
      padding-bottom: 10px;
      margin: 0;
      font-family: HelveticaNeue, Helvetica, Arial, sans-serif !important;
    }
  `}
`;

export const Triangle = styled.div`
  margin-right: 4%;
  height: 0px;
  width: 0px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 12px solid rgba(0, 103, 120, 0.15);
`;

export const TriangleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const FilterTriangle = styled.div`
  position: absolute;
  top: -12px;
  right:${props => props.right ? '20px' : 'initial'};
  height: 0px;
  width: 0px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 12px solid rgba(0, 103, 120, 0.15);
`;

export const FilterTitle = styled.p`
  color: ${props => props.theme.fontColors.thead};
`;